import { request } from '@/utils/utils.js'

let mixin = {

  data () {
    this.$validator.extend('verifyVAWithdrawAmount', {
      validate: (value, ref) => {
        const data = this.virtualAccountData[ref[0]]
        if (!data.currency) {
          return true
        }
        if (Number(value) > data.balance) {
          return false
        }
        return true
      },
      getMessage: (field) => 'The withdrawal amount should be less than the balance'
    })
    return {
      // To Virtual Account 需求
      virtualAccount: '',
      virtualAccountData: [{ accountCurrencyStatus: false }],
      accountRemark: '',
    }
  },
  mounted () {

  },
  methods: {
    addAccountCurrency(index) {
      const newData = {accountCurrencyStatus: false}
      this.virtualAccountData.push(newData)
    },
    minusAccountCurrency(index) {
      this.virtualAccountData.splice(index, 1)
    },
    isAccountCurrencyValid(item) {
			let isValid = false
			if (item.accountCurrencyStatus) {
				isValid = true
			}
			return isValid
		},
    withdrawToVirtualRequest(params) {
      const that = this;
      that.loadingFullScreen('withdrawToVirtualLoading', 'loading', 'fa fa-hourglass-half')
      const access_token = localStorage.getItem("Authorization")
      request({
        method: "post",
        url: `api/dashboard/merchant/assets/batch-withdraw-virtual-account?access_token=${access_token}`,
        data: params,
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(res => {
          that.withdrawToVirtualLoading.close()
          let data = res.data;
          if (data.code === "10000") {
            that.resetToBankForm()
            that.$message({
              type: "success",
              duration: 5000,
              message: data.msg
            });
            that.$refs.withdraw.close()
            that.queryRevenueList();
            that.$refs.financeTabs.selectTab('#va-wallet-history')
          } else if (data.code === "20010") {
            that.$message({ type: "error", duration: 5000, message: 'The amount you specified for withdrawal is less than minimum amount. Please double check the amount and try again.' });
          } else {
            that.$message({ type: "error", duration: 5000, message: data.msg });
          }
        })
        .catch(err => { });
    },
    loadingFullScreen (controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
  }
}

export default mixin
